import { useState, useRef, useEffect } from "react";
import axios from "axios";
import config from "./config";

export default function Checkin() {
  const [bgColor, setBgColor] = useState("white");
  const [labelData, setLabelData] = useState("");
  const [textField, setTextField] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    document.body.style.backgroundColor = bgColor;
  }, [bgColor]);

  const handleFocus = (e) => e.target.select();

  const baseURL = `${config.apiUrl}/checkin`;

  const runCheckin = async () => {
    // UI reset
    inputRef.current?.select();
    setBgColor("white");
    setLabelData("Lädt...");

    try {
      const payload = { code: (textField || "").trim() };

      const res = await axios.post(baseURL, payload, {
        headers: { "Content-Type": "application/json" },
        // 4xx (inkl. 404) NICHT throwen lassen:
        validateStatus: (s) => s >= 200 && s < 500,
      });

      console.log("[checkin] status:", res.status, "data:", res.data);

      switch (res.status) {
        case 200: {
          const vorname = res.data?.vorname ?? "";
          const nachname = res.data?.nachname ?? "";
          const nameText =
            vorname || nachname
              ? `Erfolgreich eingecheckt: ${vorname} ${nachname}`.trim()
              : "Erfolgreich eingecheckt";
          setLabelData(nameText);
          setBgColor("lightgreen");
          break;
        }
        case 201: {
          setLabelData("Bereits eingecheckt");
          setBgColor("LemonChiffon");
          break;
        }
        case 404: {
          // z. B. { message: "Registration not found" } oder "Event not found"
          setLabelData(res.data?.message || "Anmeldung nicht gefunden");
          setBgColor("#FFCCCB");
          break;
        }
        case 400: {
          setLabelData(res.data?.message || "Ungültige Eingabe");
          setBgColor("#FFCCCB");
          break;
        }
        default: {
          setLabelData("Unerwartete Server-Antwort");
          setBgColor("#FFCCCB");
        }
      }
    } catch (err) {
      console.error("[checkin] request failed:", err);
      setLabelData("Netzwerk-/CORS-Fehler");
      setBgColor("#FFCCCB");
    } finally {
      // Scanner-Komfort: markiert lassen
      inputRef.current?.select();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    runCheckin();
  };

  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <center>
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: 40 }}>
            Code:
            <input
              onChange={(e) => setTextField(e.target.value)}
              style={{ fontSize: 40 }}
              type="text"
              id="inputname"
              autoFocus
              ref={inputRef}
              onFocus={handleFocus}
              name="inputname"
            />
          </label>
          <br />
          <br />
          <button style={{ fontSize: 40 }} type="submit" value="Einchecken">
            Einchecken
          </button>
          <br />
          <br />
          <br />
          <b>{labelData}</b>
        </form>
      </center>
    </>
  );
}
